// extracted by mini-css-extract-plugin
export default {"titleRow":"jt_8PmnAthdC2pnR5ksW"};